import Label from '@material-ui/icons/Label';
import Warning from '@material-ui/icons/Warning';

export const WarningIcon = Warning;
export const LabelIcon = Label;
